import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys } from "vue"
import _imports_0 from '@/assets/icons/plus-gray.svg'


const _hoisted_1 = { class: "flex flex-col mt-4" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row justify-between items-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Payment breakdown (USD)", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "flex flex-row justify-between items-center bg-primary-background rounded-2xl px-4 py-2"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "You're now editing this candidate profile", -1)
const _hoisted_7 = { class: "flex flex-col mt-4" }
const _hoisted_8 = { class: "flex flex-row mb-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Total Compensation / Month")
], -1)
const _hoisted_10 = { class: "font-semibold ml-4" }
const _hoisted_11 = { class: "flex flex-row mt-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Salary / Month")
], -1)
const _hoisted_13 = { class: "ml-4" }
const _hoisted_14 = { class: "flex flex-col mt-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-2" }, null, -1)
const _hoisted_16 = { class: "flex flex-row mb-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 capitalize ml-4" }, "Gross Salary")
], -1)
const _hoisted_18 = { class: "text-gray-500 ml-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-2" }, null, -1)
const _hoisted_20 = { class: "flex flex-row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 capitalize ml-4" }, "Employer Tax")
], -1)
const _hoisted_22 = { class: "text-gray-500 ml-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_24 = { class: "flex flex-row" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Benefits / Month")
], -1)
const _hoisted_26 = { class: "ml-4" }
const _hoisted_27 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-2" }, null, -1)
const _hoisted_29 = { class: "flex flex-row" }
const _hoisted_30 = { class: "w-52" }
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = ["onUpdate:modelValue"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_34 = { class: "flex flex-row items-center" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-4 h-4"
}, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-2" }, null, -1)
const _hoisted_37 = { class: "flex flex-row" }
const _hoisted_38 = { class: "w-72" }
const _hoisted_39 = { class: "text-gray-500 capitalize ml-4" }
const _hoisted_40 = { class: "text-gray-500 ml-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_42 = { class: "flex flex-row" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Christmas Bonus / Month")
], -1)
const _hoisted_44 = { class: "ml-4" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_46 = { class: "flex flex-row" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Total Axelerate Fees / Month")
], -1)
const _hoisted_48 = { class: "ml-4" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_50 = { class: "flex flex-row my-2" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Total Annual Compensation")
], -1)
const _hoisted_52 = { class: "font-semibold ml-4" }
const _hoisted_53 = { class: "flex flex-row mt-4" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Total Annual Salary")
], -1)
const _hoisted_55 = { class: "ml-4" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_57 = { class: "flex flex-row" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Total Annual Benefits")
], -1)
const _hoisted_59 = { class: "ml-4" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_61 = { class: "flex flex-row" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Total Annual Christmas Bonus")
], -1)
const _hoisted_63 = { class: "ml-4" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_65 = { class: "flex flex-row" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Total Annual Axelerate Fees")
], -1)
const _hoisted_67 = { class: "ml-4" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.editing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.finishEditing && _ctx.finishEditing(...args))),
            class: "rounded-full bg-primary text-white px-6 py-2"
          }, " Done editing ")
        ])),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("span", _hoisted_10, " $" + _toDisplayString((
              (_ctx.info.gross_salary * 2 +
                _ctx.info.employer_taxes * 2 +
                _ctx.info.benefits_total * 2 +
                _ctx.info.christmas_bonus * 2 +
                _ctx.info.axelerate_percent * 2) /
              100
            ).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("span", _hoisted_13, " $" + _toDisplayString((
              (_ctx.info.gross_salary * 2 + _ctx.info.employer_taxes * 2) /
              100
            ).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 1)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("span", _hoisted_18, " $" + _toDisplayString(((_ctx.info.gross_salary * 2) / 100).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })), 1)
        ]),
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("span", _hoisted_22, " $" + _toDisplayString(((_ctx.info.employer_taxes * 2) / 100).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })), 1)
        ])
      ]),
      _hoisted_23,
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("span", _hoisted_26, " $" + _toDisplayString(((_ctx.info.benefits_total * 2) / 100).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 1)
      ]),
      (_ctx.editing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.benefits, (val, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "flex flex-col mt-2"
              }, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((_ctx.info.benefits[i].name) = $event),
                      placeholder: "Name",
                      type: "text",
                      class: "bg-background rounded-2xl p-4 focus:outline-none"
                    }, null, 8, _hoisted_31), [
                      [_vModelText, _ctx.info.benefits[i].name]
                    ])
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((_ctx.info.benefits[i].value) = $event),
                    placeholder: "Amount",
                    type: "text",
                    class: "bg-background rounded-2xl p-2 ml-4 focus:outline-none"
                  }, null, 8, _hoisted_32), [
                    [_vModelText, _ctx.info.benefits[i].value]
                  ])
                ])
              ]))
            }), 128)),
            _hoisted_33,
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newBenefit.name) = $event)),
                placeholder: "New item",
                type: "text",
                class: "bg-background rounded-2xl p-2 ml-4 focus:outline-none"
              }, null, 512), [
                [_vModelText, _ctx.newBenefit.name]
              ]),
              _withDirectives(_createElementVNode("input", {
                onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.addBenefit && _ctx.addBenefit(...args)), ["enter"])),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newBenefit.value) = $event)),
                placeholder: "Amount",
                type: "text",
                class: "bg-background rounded-2xl p-2 ml-4 focus:outline-none"
              }, null, 544), [
                [_vModelText, _ctx.newBenefit.value]
              ])
            ])
          ]))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.info.benefits, (val, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "flex flex-col mt-2"
            }, [
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("span", _hoisted_39, _toDisplayString(val.name), 1)
                ]),
                _createElementVNode("span", _hoisted_40, " $" + _toDisplayString((val.value / 100).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })), 1)
              ])
            ]))
          }), 128)),
      _hoisted_41,
      _createElementVNode("div", _hoisted_42, [
        _hoisted_43,
        _createElementVNode("span", _hoisted_44, " $" + _toDisplayString(((_ctx.info.christmas_bonus * 2) / 100).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 1)
      ]),
      _hoisted_45,
      _createElementVNode("div", _hoisted_46, [
        _hoisted_47,
        _createElementVNode("span", _hoisted_48, " $" + _toDisplayString(((_ctx.info.axelerate_percent * 2) / 100).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 1)
      ]),
      _hoisted_49,
      _createElementVNode("div", _hoisted_50, [
        _hoisted_51,
        _createElementVNode("span", _hoisted_52, " $" + _toDisplayString((
              (_ctx.info.gross_salary * 24 +
                _ctx.info.employer_taxes * 24 +
                _ctx.info.benefits_total * 24 +
                _ctx.info.christmas_bonus * 24 +
                _ctx.info.axelerate_percent * 24) /
              100
            ).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 1)
      ]),
      _createElementVNode("div", _hoisted_53, [
        _hoisted_54,
        _createElementVNode("span", _hoisted_55, " $" + _toDisplayString((
              (_ctx.info.gross_salary * 24 + _ctx.info.employer_taxes * 24) /
              100
            ).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 1)
      ]),
      _hoisted_56,
      _createElementVNode("div", _hoisted_57, [
        _hoisted_58,
        _createElementVNode("span", _hoisted_59, " $" + _toDisplayString(((_ctx.info.benefits_total * 24) / 100).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 1)
      ]),
      _hoisted_60,
      _createElementVNode("div", _hoisted_61, [
        _hoisted_62,
        _createElementVNode("span", _hoisted_63, " $" + _toDisplayString(((_ctx.info.christmas_bonus * 24) / 100).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 1)
      ]),
      _hoisted_64,
      _createElementVNode("div", _hoisted_65, [
        _hoisted_66,
        _createElementVNode("span", _hoisted_67, " $" + _toDisplayString(((_ctx.info.axelerate_percent * 24) / 100).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 1)
      ]),
      _hoisted_68
    ])
  ]))
}